import { API_ENDPOINTS } from '../constants/api-endpoints';
import { API, API_UPLOAD } from './api-config';

const { QUESTION } = API_ENDPOINTS;
const {
  FIND_ALL,
  FIND_ONE,
  UPDATE_ONE,
  DELETE_ONE,
  CREATE_ONE,
  UPLOAD,
  FIELDS,
  CATEGORIES,
  DIFFICULTY_LEVELS,
} = QUESTION;

export const ApiQuestion = {
  fetchAll: (params?: Record<string, any>) => {
    return API({
      path: FIND_ALL,
      method: 'GET',
      params,
    });
  },
  fetchOne: (id: string | number) => {
    return API({
      path: FIND_ONE,
      method: 'GET',
      pathParams: { id },
    });
  },
  createOne: (data: Record<string, any>) => {
    return API({
      path: CREATE_ONE,
      method: 'POST',
      data,
    });
  },
  updateOne: (id: string | number, data: Record<string, any>) => {
    return API({
      path: UPDATE_ONE,
      method: 'PUT',
      pathParams: { id },
      data,
    });
  },
  deleteOne: (id: string | number) => {
    return API({
      path: DELETE_ONE,
      method: 'DELETE',
      pathParams: { id },
    });
  },
  upload: (data: Record<string, any>) => {
    return API_UPLOAD({
      path: UPLOAD,
      method: 'POST',
      data,
    });
  },
  fetchFields: () => {
    return API({
      path: FIELDS,
      method: 'GET',
    });
  },
  fetchCategories: () => {
    return API({
      path: CATEGORIES,
      method: 'GET',
    });
  },
  fetchDifficultyLevels: () => {
    return API({
      path: DIFFICULTY_LEVELS,
      method: 'GET',
    });
  },
};
